import Vue from 'vue'
import gsap from 'gsap'

const moveInObserver = new Vue({
  data() {
    return {
      observer: null,
      // 需要加载的元素
      loadStack: [],
      timeOut: null
    }
  },
  methods: {
    shiftStack() {
      if (this.timeOut) {
        return
      }
      if (this.loadStack.length) {
        const el = this.loadStack.shift()
        gsap.set(el, {
          transition: 'none',
          opacity: 0,
          yPercent: 20
        })
        gsap.to(el, {
          transform: null,
          opacity: 1,
          yPercent: 0,
          duration: 0.3
        })
        this.timeOut = setTimeout(() => {
          clearTimeout(this.timeOut)
          this.timeOut = null
          this.shiftStack()
        }, 100)
      }
    },
    initObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target
              if (el) {
                this.observer.unobserve(el) // 加载后停止观察
                this.loadStack.push(el)
                this.shiftStack()
              }
            }
          })
        },
        {
          rootMargin: '0px 0px 0px 0px', // 提前200px加载
          threshold: 0.1
        }
      )
    }
  },
  mounted() {
    this.initObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect() // 销毁前断开观察器
    }
  }
})

// 注册全局指令
Vue.directive('movein', {
  inserted(el) {
    if (moveInObserver.observer) {
      if (
        !el.style.transform &&
        !el.style.opacity &&
        el.style.opacity !== '0'
      ) {
        el.style.opacity = '0'
        moveInObserver.observer.unobserve(el)
        moveInObserver.observer.observe(el)
      }
    }
  },
  unbind(el) {
    if (moveInObserver.observer) {
      moveInObserver.observer.unobserve(el)
    }
  }
})
Vue.prototype.$moveInObserver = moveInObserver
